module.exports = __webpack_public_path__ + "img/qisi.4e5fd194.png";